import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axiosClient from "./axiosClient";
import { useAuth } from "../Context/AuthUser";

export default function Logout() {
  const navigate = useNavigate();
  const { setUser, setNotification } = useAuth();

  useEffect(() => {
    axiosClient.post("/auth/logout.php")
      .catch(() => { })
      .finally(() => {
        
        setUser(null);
        setNotification([]);

        localStorage.clear();
        navigate("/login", { replace: true });
        window.location.reload();
      });
  }, [navigate, setUser, setNotification]);
 
  return <p>Logging out...</p>;
}